import { chamberDistrictLabel, effectiveTargetRows } from '../recruit/recruitCoverage'
import type { ScheduleMeetingDto, TargetCoverageDto } from '../../../types/lobbyDay'

export interface CoverageRow {
  legislatorId: string
  name: string
  districtLabel: string
  isPriority: boolean
}

export interface CoveragePartition {
  total: number
  scheduled: number
  unscheduled: CoverageRow[]
}

/** Effective target legislators split into scheduled vs. not. "Scheduled" = a meeting
 *  references the legislator anywhere in the event (NOT TargetCoverageDto.isGap, which is
 *  a constituent count). Unscheduled rows sort priority-first, then by name. */
export function partitionCoverage(
  rows: TargetCoverageDto[],
  targetAll: boolean,
  meetings: ScheduleMeetingDto[],
): CoveragePartition {
  const eff = effectiveTargetRows(rows, targetAll)
  const scheduledLegIds = new Set(meetings.map((m) => m.legislatorId))
  const unscheduled = eff
    .filter((r) => !scheduledLegIds.has(r.legislatorId))
    .map((r) => ({
      legislatorId: r.legislatorId,
      name: r.legislatorName,
      districtLabel: chamberDistrictLabel(r.chamber, r.district),
      isPriority: r.isPriority,
    }))
    .sort((a, b) => Number(b.isPriority) - Number(a.isPriority) || a.name.localeCompare(b.name))
  return { total: eff.length, scheduled: eff.length - unscheduled.length, unscheduled }
}
